import { render } from "./OptionForm.vue?vue&type=template&id=9c8e49e0"
import script from "./OptionForm.vue?vue&type=script&lang=js"
export * from "./OptionForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__